import type { ISlug } from 'types';
import type { PermissionsType } from 'store/models/userStore';

export interface IRights extends ISlug {
  hasTab: boolean;
}

/** Права пользователя по slug, включая общедоступный раздел «Сообщения». */
export const getRights = (
  slug: string,
  permissions: PermissionsType
): IRights => {
  const tab = permissions.get(slug);
  const isPublic = slug === 'all';

  return {
    create: tab?.rights.create || isPublic,
    read: tab?.rights.read || isPublic,
    update: tab?.rights.update || isPublic,
    delete: tab?.rights.delete || isPublic,
    hasTab: !!tab,
  };
};
